<!-- <div
  class="image-container container"
  style="background-image: url('/assets/images/lifestyle/facilitati.jpg')"
>
  <h3
    class="title"
  >
    Facilități
  </h3>
</div> -->

<h1
  class="page-title"
>
  Facilități
</h1>

<div
  class="container"
  fxLayout="column"
  fxLayoutAlign="center center"
  fxLayoutGap="20px"
>
  <div
    fxLayout.gt-xs="row"
    fxLayout="column"
    fxLayoutGap="20px"
  >
    <div
      *ngFor="let reason of [reasons[0], reasons[1]]"
      fxLayout="column"
      fxLayoutAlign="start center"
      class="lifestyle-item"
    >
      <img [src]="reason.image.url" alt="" class="icon" loading="lazy">
      <h3 class="title">
        {{ reason.title }}
      </h3>
      <p>
        {{ reason.content }}
      </p>
    </div>
  </div>
  <div
    fxLayout.gt-xs="row"
    fxLayout="column"
    fxLayoutGap="20px"
  >
    <div
      *ngFor="let reason of [reasons[2], reasons[3]]"
      fxLayout="column"
      fxLayoutAlign="start center"
      class="lifestyle-item"
    >
      <img [src]="reason.image.url" alt="" class="icon" loading="lazy">
      <h3 class="title">
        {{ reason.title }}
      </h3>
      <p>
        {{ reason.content }}
      </p>
    </div>
  </div>
  <div
    fxLayout.gt-xs="row"
    fxLayout="column"
    fxLayoutGap="20px"
  >
    <div
      *ngFor="let reason of [reasons[4], reasons[5]]"
      fxLayout="column"
      fxLayoutAlign="start center"
      class="lifestyle-item"
    >
      <img [src]="reason.image.url" alt="" class="icon" loading="lazy">
      <h3 class="title">
        {{ reason.title }}
      </h3>
      <p>
        {{ reason.content }}
      </p>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/about-us/facilities.component.html